export enum UserType {
  REGULAR = 1,
  OWNER,
  ADMIN
}
